export default __webpack_public_path__ + "static/media/product-overview-bg.c8e70349.webp";